import PrivateMenuBar from './PrivateMenuBar'

export default PrivateMenuBar
